import { useRouter } from 'next/router';
import { labels, Language } from './labels';

export function useLabels() {
  const { locale = 'en' } = useRouter();

  const getLabel = (path: string, values?: Record<string, string>) => {
    const parts = path.split('.');
    let result: any = labels[locale as Language] ?? labels.en;

    for (const part of parts) {
      result = result?.[part];
      if (result === undefined) {
        // Fallback to English if translation is missing
        result = labels.en;
        for (const p of parts) {
          result = result?.[p];
        }
        break;
      }
    }

    if (values) {
      result = result.replace(/{(\d+)}/g, (match, p1) => values[p1] || match);
    }

    return result ?? path;
  };

  return { getLabel };
}
